<template>
	<div>
		<productCenNav ref="productCenNav" :list="navList" @goScroll="goScroll" v-show="cenNavHidden"></productCenNav>
		<template v-for="(item,index) in navList">
			<component :is="mapComponent[item.value]" :list='item' :ref="item.value+'a'+index" @goScroll='event=>goScroll(event,index)' />
		</template>
	</div>
</template>

<script>
	import productCenNav from "./productCenNav"
	import mapComponent from "@/components/mapComponentTwo.js";
	export default {
		components: {
			productCenNav,
		},
		data() {
			return {
				mapComponent,
				navList: [
					
				],
				navHidden: false,
				scrollTop: 0,
				scrollTopNav: 0,
				cenNavHidden: true,
				navTop:[],
				querValue:'',
				info:''
			}
		},
		watch: {
			scrollTop() {
				if (this.scrollTop < this.scrollTopNav) {
					this.cenNavHidden = true;
				}
				this.navList.map((v,a)=>{
					if(!v.name){
						return;
					}
					if(a+1==this.navList.length){
						if ((this.scrollTop+70) > this.navTop[a]) {
							this.$refs.productCenNav.current=a;
						}
					}else{
						if ((this.scrollTop+70) > this.navTop[a]&&(this.scrollTop+70)< this.navTop[a+1]) {
							this.$refs.productCenNav.current=a;
						}
					}
				})
			},
			querValue(){
				let t=this;
				console.log(this.querValue,"aaaaaaaaaaaaaaaaaaaa")
				this.$nextTick(function(){
					t.setTop();
				})
			},
			navList(){
				let t=this;
				
				this.$nextTick(function(){
					var element;
					if(this.nowVibe=='pc'){
						element= document.documentElement
					}else{
						element = document.documentElement.scrollTop ? document.documentElement : document.body;
					}
					t.scrollTop = element.scrollTop;
					t.setTop();
					t.getTop();
				})
			},
			navTop(){
				if (this.scrollTop < this.scrollTopNav) {
					this.cenNavHidden = true;
				}
				this.navList.map((v,a)=>{
					if(!v.name){
						return;
					}
					if(a+1==this.navList.length){
						if ((this.scrollTop+70) > this.navTop[a]) {
							this.$refs.productCenNav.current=a;
						}
					}else{
						if ((this.scrollTop+70) > this.navTop[a]&&(this.scrollTop+70)< this.navTop[a+1]) {
							this.$refs.productCenNav.current=a;
						}
					}
				})
			}
		},
		mounted() {
			let t=this;
			let offsetTop = this.$refs.productCenNav.$el.offsetTop;
			this.scrollTopNav = offsetTop;
			window.addEventListener('scroll', this.handleScroll);
			this.querValue=this.$route.query.value;
			// t.setList();
		},
		beforeDestroy() {
			window.removeEventListener('scroll', this.handleScroll);
		},
		methods: {
			setTop(){
				this.navList.map((v,a)=>{
					if(!v.name){
						return;
					}
					if(this.querValue==v.value){
						this.$refs.productCenNav.current=a;
						this.goScroll(this.querValue,a)
					}
				})
			},
			getTop(){
				let top=[];
				this.navList.map((v,a)=>{
					console.log('-----开始-----')
					console.log(v.value+'a'+a)
					console.log(this.$refs[v.value+'a'+a])
					console.log(this.$refs[v.value+'a'+a][0])
					console.log(this.$refs[v.value+'a'+a][0].$el.offsetTop)
					let stop=this.$refs[v.value+'a'+a][0].$el.offsetTop
					top.push(stop-100)
					console.log('-----结束-----')
				})
				this.$nextTick(function() {
					this.navTop = top;
					console.log(this.navTop,"107啊啊啊啊啊啊啊啊啊啊啊啊")
				})
			},
			goScroll(e,index) {
				console.log(e+'a'+index,this.$refs[e+'a'+index])
				let offsetTop = this.$refs[e+'a'+index][0].$el.offsetTop - 70;
				this.$emit('goScroll',offsetTop)
				// document.documentElement.scrollTop = offsetTop+10;
			},
			handleScroll(e) {
				var element;
				if(this.nowVibe=='pc'){
					element= document.documentElement
				}else{
					element = document.documentElement.scrollTop ? document.documentElement : document.body;
				}
				this.scrollTop = element.scrollTop;
			},
			setInfo(e){
				this.info=e;
				let list=e.modules;
				list.forEach((v,a)=>{
					if(v.data&&v.data.menuName){
						v.name=v.data.menuName
					}else{
						v.name=''
					}
					v.value=v.code;
					if(a<list.length-1){
						if(v.value==list[a+1].code){
							list[a+1].top=0
						}
					}
				})
				// let listTwo=[
				// 	{
				// 		name: '',
				// 		value: 'data86',
				// 		top:0
				// 	},
				// ]
				this.$nextTick(function(){
					// this.navList=[...list,...listTwo];
					this.navList=list;
					this.$refs.productCenNav.setList(this.navList)
				})
			},
			setList(){
				let t=this;
				let id = this.$route.query.id;
				let arr=[]
				// 周边产品
				if(Number(id)==1){
					 arr=[
						{
							name: this.$t('i18n_93'),
							value: 'data1',
						},
						{
							name: this.$t('i18n_94'),
							value: 'data2',
						},
						{
							name: this.$t('i18n_95'),
							value: 'data3',
						},
						{
							name: this.$t('i18n_96'),
							value: 'data4',
						},
						{
							name: this.$t('i18n_97'),
							value: 'null',
						},
					];
				};
				if(Number(id)==2){
					 arr=[
						{
							name: this.$t('i18n_98'),
							value: 'data5',
						},
						{
							name: this.$t('i18n_99'),
							value: 'data6',
						},
						{
							name: this.$t('i18n_100'),
							value: 'data7',
						},
					];
				};
				if(Number(id)==3){
					 arr=[
						{
							name: this.$t('i18n_101'),
							value: 'data8',
						},
						{
							name: this.$t('i18n_102'),
							value: 'data9',
						},
						{
							name: this.$t('i18n_103'),
							value: 'data10',
						},
					];
				};
				if(Number(id)==4){
					 arr=[
						{
							name: this.$t('i18n_104'),
							value: 'data11',
						},
						{
							name: this.$t('i18n_105'),
							value: 'data12',
						},
					];
				};
				if(Number(id)==5){
					 arr=[
						{
							name: this.$t('i18n_106'),
							value: 'data13',
						},
						{
							name: this.$t('i18n_107'),
							value: 'data14',
						},
						{
							name: this.$t('i18n_108'),
							value: 'data15',
						},
					];
				};
				// 内镜系统
				if(Number(id)==6){
					 arr=[
						{
							name: this.$t('i18n_109'),
							value: 'data16',
							valueTwo: 'data85',
						},
						{
							name: this.$t('i18n_110'),
							value: 'data17',
						},
						{
							name: this.$t('i18n_111'),
							value: 'data18',
						},
						{
							name: this.$t('i18n_112'),
							value: 'data19',
						},
						{
							name: this.$t('i18n_113'),
							value: 'null',
						},
						{
							name: this.$t('i18n_114'),
							value: 'data20',
						},
					];
				};
				if(Number(id)==7){
					 arr=[
						{
							name: this.$t('i18n_115'),
							value: 'data21',
						},
						{
							name: this.$t('i18n_116'),
							value: 'data22',
						},
						{
							name: this.$t('i18n_117'),
							value: 'data23',
						},
						{
							name: this.$t('i18n_118'),
							value: 'data24',
						},
						{
							name: this.$t('i18n_119'),
							value: 'data25',
						},
						{
							name: this.$t('i18n_120'),
							value: 'null',
						},
						{
							name: this.$t('i18n_121'),
							value: 'data26',
						},
					];
				};
				if(Number(id)==8){
					 arr=[
						{
							name: this.$t('i18n_122'),
							value: 'data27',
						},
						{
							name: this.$t('i18n_123'),
							value: 'data28',
						},
						{
							name: this.$t('i18n_124'),
							value: 'data29',
						},
						{
							name: this.$t('i18n_125'),
							value: 'data30',
						},
						{
							name: this.$t('i18n_126'),
							value: 'data31',
						},
						{
							name: this.$t('i18n_127'),
							value: 'data32',
						},
						{
							name: this.$t('i18n_128'),
							value: 'data26',
						},
					];
				};
				if(Number(id)==9){
					 arr=[
						{
							name: this.$t('i18n_129'),
							value: 'data33',
						},
						{
							name: this.$t('i18n_130'),
							value: 'data34',
						},
						{
							name: this.$t('i18n_131'),
							value: 'data35',
						},
						{
							name: this.$t('i18n_132'),
							value: 'data36',
						},
						{
							name: this.$t('i18n_133'),
							value: 'data26',
						},
					];
				};
				if(Number(id)==10){
					 arr=[
						{
							name: this.$t('i18n_134'),
							value: 'data28',
						},
						{
							name: this.$t('i18n_135'),
							value: 'data34',
						},
						{
							name: this.$t('i18n_136'),
							value: 'data35',
						},
						{
							name: this.$t('i18n_137'),
							value: 'data32',
						},
						{
							name: this.$t('i18n_138'),
							value: 'data26',
						},
					];
				};
				if(Number(id)==11){
					 arr=[
						 {
						 	name: this.$t('i18n_139'),
						 	value: 'data28',
						 },
						{
							name: this.$t('i18n_140'),
							value: 'data28',
						},
						{
							name: this.$t('i18n_141'),
							value: 'data34',
						},
						{
							name: this.$t('i18n_142'),
							value: 'data35',
						},
						{
							name: this.$t('i18n_143'),
							value: 'data26',
						},
					];
				};
				
				if(Number(id)==12){
					 arr=[
						 {
						 	name: this.$t('i18n_144'),
						 	value: 'data37',
						 },
						{
							name: this.$t('i18n_145'),
							value: 'data38',
						},
						{
							name: this.$t('i18n_146'),
							value: 'data39',
						},
						{
							name: this.$t('i18n_147'),
							value: 'data40',
						},
						{
							name: this.$t('i18n_148'),
							value: 'data41',
						},
					];
				};
				// 电子内镜
				if(Number(id)==13){
					 arr=[
						 {
						 	name: this.$t('i18n_149'),
						 	value: 'data42',
						 },
						{
							name: this.$t('i18n_150'),
							value: 'data43',
						},
						{
							name: this.$t('i18n_151'),
							value: 'data44',
						},
						{
							name: this.$t('i18n_152'),
							value: 'data45',
						},
						{
							name: this.$t('i18n_153'),
							value: 'data41',
						},
						{
							name: this.$t('i18n_154'),
							value: 'data26',
						},
					];
				};
				if(Number(id)==14){
					 arr=[
						 {
						 	name: this.$t('i18n_155'),
						 	value: 'data46',
						 },
						{
							name: this.$t('i18n_156'),
							value: 'data47',
						},
						{
							name: this.$t('i18n_157'),
							value: 'data48',
						},
						{
							name: this.$t('i18n_158'),
							value: 'data49',
						},
						{
							name: this.$t('i18n_159'),
							value: 'data41',
						},
						{
							name: this.$t('i18n_160'),
							value: 'data26',
						},
					];
				};
				if(Number(id)==15){
					 arr=[
						 {
						 	name: this.$t('i18n_161'),
						 	value: 'data50',
						 },
						{
							name: this.$t('i18n_162'),
							value: 'data51',
						},
						{
							name: this.$t('i18n_163'),
							value: 'data52',
						},
						{
							name: this.$t('i18n_164'),
							value: 'data53',
						},
						{
							name: this.$t('i18n_165'),
							value: 'data54',
						},
						{
							name: this.$t('i18n_166'),
							value: 'data41',
						},
						{
							name: this.$t('i18n_167'),
							value: 'data26',
						},
					];
				};
				if(Number(id)==16){
					 arr=[
						 {
						 	name: this.$t('i18n_168'),
						 	value: 'data55',
						 },
						{
							name: this.$t('i18n_169'),
							value: 'data56',
						},
						{
							name: this.$t('i18n_170'),
							value: 'data57',
						},
						{
							name: this.$t('i18n_171'),
							value: 'data26',
						},
					];
				};
				if(Number(id)==17){
					 arr=[
						 {
						 	name: this.$t('i18n_172'),
						 	value: 'data58',
						 },
						{
							name: this.$t('i18n_173'),
							value: 'data59',
						},
						{
							name: this.$t('i18n_174'),
							value: 'data60',
						},
						{
							name: this.$t('i18n_175'),
							value: 'data61',
						},
						{
							name: this.$t('i18n_176'),
							value: 'data62',
						},
						{
							name: this.$t('i18n_177'),
							value: 'data26',
						},
					];
				};
				if(Number(id)==18){
					 arr=[
						 {
						 	name: this.$t('i18n_178'),
						 	value: 'data63',
						 },
						{
							name: this.$t('i18n_179'),
							value: 'data64',
						},
						{
							name: this.$t('i18n_180'),
							value: 'data65',
						},
						{
							name: this.$t('i18n_181'),
							value: 'data66',
						},
						{
							name: this.$t('i18n_182'),
							value: 'data26',
						},
					];
				};
				if(Number(id)==19){
					 arr=[
						 {
						 	name: this.$t('i18n_183'),
						 	value: 'data67',
						 },
						{
							name: this.$t('i18n_184'),
							value: 'data68',
						},
						{
							name: this.$t('i18n_185'),
							value: 'data69',
						},
						{
							name: this.$t('i18n_186'),
							value: 'data70',
						},
						{
							name: this.$t('i18n_187'),
							value: 'data26',
						},
					];
				};
				if(Number(id)==20){
					 arr=[
						 {
						 	name: this.$t('i18n_188'),
						 	value: 'data71',
						 },
						{
							name: this.$t('i18n_189'),
							value: 'data72',
						},
						{
							name: this.$t('i18n_190'),
							value: 'data73',
						},
						{
							name: this.$t('i18n_191'),
							value: 'data74',
						},
						{
							name: this.$t('i18n_192'),
							value: 'data75',
						},
						{
							name: this.$t('i18n_193'),
							value: 'data26',
						},
					];
				};
				if(Number(id)==21){
					 arr=[
						 {
						 	name: this.$t('i18n_194'),
						 	value: 'data76',
						 },
						{
							name: this.$t('i18n_195'),
							value: 'data77',
						},
						{
							name: this.$t('i18n_196'),
							value: 'data78',
						},
						{
							name: this.$t('i18n_197'),
							value: 'data79',
						},
						{
							name: this.$t('i18n_198'),
							value: 'data80',
						},
						{
							name: this.$t('i18n_199'),
							value: 'data75',
						},
						{
							name: this.$t('i18n_200'),
							value: 'data26',
						},
					];
				};
				if(Number(id)==22){
					 arr=[
						 {
						 	name: this.$t('i18n_201'),
						 	value: 'data81',
						 },
						{
							name: this.$t('i18n_202'),
							value: 'data82',
						},
						{
							name: this.$t('i18n_203'),
							value: 'data83',
						},
						{
							name: this.$t('i18n_204'),
							value: 'data84',
						},
						{
							name: this.$t('i18n_205'),
							value: 'data75',
						},
						{
							name: this.$t('i18n_206'),
							value: 'data26',
						},
					];
				};
				this.navList=arr;
				// this.$nextTick(function(){
				// 	t.scrollTop = document.documentElement.scrollTop;
				// 	t.getTop();
				// })
			}
		}
	}
</script>

<style>

</style>
<style scoped lang="scss">

</style>